<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{type}} -->
        <!-- {{ value }} -->
        <b-card class="standardpage border-none ">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="openingbalances.icon" class="mr-1"></i>
                        <span>{{ openingbalances.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div class="mt-2 availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0 px-0">
                        <b-row>
                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="NL A/C" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="nlcode" :debounce="openingbalances.debounce"
                                            placeholder="NL A/C"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!nlcode"
                                                @click="nlcode = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Description" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="description" :debounce="openingbalances.debounce"
                                            placeholder="Description"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!description"
                                                @click="description = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Period" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="period" :debounce="openingbalances.debounce"
                                            placeholder="Period"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!period"
                                                @click="period = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col> -->

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Transaction Date" label-size="sm">
                                    <b-input-group class="treeselect_all" style="left:88px; top:-13px">
                                        <i id="date_at" class="fa fa-info-circle text-black"></i>
                                    </b-input-group>
                                    <b-tooltip target="date_at" triggers="hover" placement="top">Transaction
                                        Date
                                    </b-tooltip>
                                    <b-input-group>
                                        <daterangepicker class="w-auto" size="sm" ref="date_at" v-model="date_at"
                                            :opens="'right'" :locale-data="locale_data" :ranges="false"
                                            :showDropdowns="true" :single-date-picker="'true'" :disabled="readonly"
                                            @update="edited = true">
                                        </daterangepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="date_at = {
                                                startDate: null,
                                                endDate: null,
                                            }
                                                ">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- :show="!blac" -->
                        <b-overlay opacity="0.3">
                            <template #overlay>
                                <b-icon icon=""></b-icon>

                            </template>
                            <div class="mt-0 mb-1 text-center nested availtable datatable smallinputs">
                                <table class="w-100pct table b-table table-striped table-hover table-sm mb-1"
                                    style="table-layout:fixed">
                                    <!-- <tr class="header-dark"> -->
                                    <tr class="header-primary text-white">

                                        <td colspan="2" class="text-center w-30px">Lines </td>

                                        <td class="text-center w-50pct" v-if="columns.includes('code')">
                                            NL Code
                                        </td>

                                        <td class="text-right w-120px" v-if="columns.includes('amount')">
                                            Amount
                                        </td>

                                        <td class="text-center w-50px" v-if="columns.includes('period')">
                                            Period
                                        </td>

                                         <td class="text-center w-35px" v-if="columns.includes('updated_by')">
                                            Updated By
                                        </td>

                                        <td class="text-center w-70px" v-if="columns.includes('updated_at')">
                                            Updated At
                                        </td>                                       

                                        <td role="columnheader" scope="col" aria-colindex="1"
                                            class="table-b-table-default text-center w-25px">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td colspan="7"></td>
                                    </tr>
                                    <tbody role="rowgroup">
                                        <tr v-for="(line, index) in openingbalances.items" :key="index">

                                            <td class="">
                                                <span class="small text-primary">{{ index + 1 }}.</span>
                                            </td>
                                            <td class="">
                                                <i :class="openingbalances.icon" class="mr-2"></i>
                                            </td>

                                            <td v-if="columns.includes('code')">
                                                <b-form-group class="">
                                                    <b-input-group>
                                                        <treeselect instanceId="code" v-model="line.code"
                                                            :clearable="true" :options="nlcode_options"
                                                            :multiple="false" class="h-20px" @select="edited = true">
                                                        </treeselect>
                                                    </b-input-group>
                                                </b-form-group>
                                            </td>


                                            <td v-if="columns.includes('amount')">
                                                <b-form-group class="mb-3px">
                                                    <b-input-group>
                                                        <b-form-input size="sm" v-model="line.amount"
                                                            placeholder="Amount" class="text-right"
                                                            :formatter="nocomma"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                @click="line.amount = '0.00'"
                                                                :disabled="line.amount == '0.00'">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>

                                                </b-form-group>
                                            </td>

                                            <td v-if="columns.includes('period')">
                                                <b-form-group class="mb-3px">
                                                    <b-input-group>
                                                        <b-form-input size="sm" v-model="line.period"
                                                            placeholder="Period" class="text-left"></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </td>

                                             <td v-if="columns.includes('updated_by')">
                                                <b-form-group class="mb-3px">
                                                    <b-input-group>
                                                        <b-form-input size="sm" v-model="line.updated_by"
                                                            placeholder="Updated By" class="text-left"
                                                            :disabled="true"></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </td>

                                            <td v-if="columns.includes('updated_at')">
                                                <b-form-group class="mb-3px">
                                                    <b-input-group>
                                                        <b-form-input size="sm" v-model="line.updated_at"
                                                            placeholder="Updated At" class="text-left"
                                                            :disabled="true"></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </td>                                           

                                            <td :id="'lines-del_' + index" class="w-30px"
                                                style="padding-left:5px !important;">
                                                <b-input-group class="m-auto w-15px">
                                                    <i class="fa fa-trash text-danger font-14px"
                                                        @click="delLine(index + 1)"></i>
                                                    <b-tooltip :target="'lines-del_' + index" placement="top">Del
                                                        line</b-tooltip>
                                                    <!-- <input id="lineCheck" style="height: 12px" type="checkbox" v-model="lines"
                        @click="toggleLine($event, index)" :checked="true" :value="line"
                        :disabled="value.lines.length == 1 || line.fare == 'N/A' || value.lines.filter(o => o.fare != 'N/A').length == 1" /> -->

                                                </b-input-group>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <b-row no-gutters>
                                    <b-col cols="auto" class="mr-3">
                                        <b-button squared size="sm" variant="primary" @click="postit_saveit"
                                            v-if="user.permissions.includes('boughtledger.save')"
                                            :disabled="postit_disabled">
                                            <i class="fa fa-check"></i>
                                            Post It
                                        </b-button>
                                    </b-col>
                                    <b-col class="text-left my-auto">
                                        <div v-if="busy">
                                            <i class="fa fa-spinner fa-spin text-primary"></i>
                                        </div>
                                        <div v-else>
                                            <span v-html="message"></span>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-overlay>
                    </b-card-body>
                </b-card>
            </div>
            <!-- {{ lines }} -->
            <b-card-footer class="mt-2 ml-1">
                <b-row>
                    <b-col class="text-right">
                        <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                            <i class="fa fa-chevron-left pr-1"></i>Back
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "OpeningBalances2",
    // props: {
    //     value: { type: Object, required: true },
    // },
    watch: {
        // async nlcode() {
        //     await this.openingbalances_load(0);
        // },
        // async description() {
        //     await this.openingbalances_load(0);
        // },
        // async period() {
        //     await this.openingbalances_load(0);
        // },
        async date_at() {
            await this.openingbalances_load(0);
        },
        value: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.lines = newVal.items
                this.edited = false
            }
        },
        lines: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                this.postit_ready()
            }
        },
    },
    async mounted() {

        try {
            const response = await this.$apollo.query({
                query: gql`
            query nlcodes {
              nlcodes {
                id
                label
              }
            }
          `,
            });
            this.nlcode_options = response.data.nlcodes;
        } catch (error) {
            console.log(error);
        }

        await this.openingbalances_load();
    },
    data() {
        return {
            busy: false,
            edited: false,
            readonly: false,
            posted: false,
            message: "",
            period: null,
            description: null,
            code: null,
            updated_at: null,
            updated_by: null,
            amount: "0.00",
            date_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },

            columns: ['code', 'description', 'amount', 'period', 'updated_at', 'updated_by'],
            columns_options: [

                {
                    id: "code",
                    label: "NL Code"
                },
                {
                    id: 'description',
                    label: 'Description'
                },
                {
                    id: 'amount',
                    label: 'Amount'
                },
                {
                    id: 'period',
                    label: 'Period'
                },
                {
                    id: 'updated_at',
                    label: 'Updated At'
                },
                {
                    id: 'updated_by',
                    label: 'Updated By'
                }
            ],
            nlcode_options: [],
            postit_disabled: true,
            openingbalances: {
                title: "Opening Balances",
                icon: "fa fa-balance-scale",
                items: [],
            }
        };
    },
    methods: {
        onlyascii(value) {
            // A SPECIFIC REPLACE
            value = value.split('b').join('')
            value = value.normalize('NFD').replace(/([\u0300-\u036f]|[^\x20-\x7E])/g, '')
            return value
        },
        linesAll(evt) {
            const list = this.allLinesChecked
                ? []
                : this.value.lines.slice(0, this.value.lines.length);
            this.lines = list;
        },
        toggleLine(evt, index) {
            console.log("toggleLine", evt, index);

            const savedIndex = this.savedIndex;
            this.savedIndex = index;

            // If this is the first pass or no shift key was
            // pressed, just bail.
            if (savedIndex === null || !evt.shiftKey) return;

            // Shift-clicked the same message :-/
            if (index === savedIndex) return;

            // Get the subset of the message list between the
            // two indicies.
            // console.time("toggle range");
            const subset = this.items.slice(
                Math.min(index, savedIndex),
                Math.max(index, savedIndex) + 1
            );
            // Determine the operation based on the checked state
            // of the clicked checkbox.
            const toggleFn = evt.currentTarget.checked
                ? addCheckedSubset
                : removeCheckedSubset;

            this.lines = toggleFn(this.lines, subset);
            console.log("these are checked", this.lines);
            // console.timeEnd("toggle range");
        },
        addLine() {
            let state = this.openingbalances;
            let _copy = { ...state.items[state.items.length - 1] }
            _copy.id = null
            _copy.code = null
            _copy.amount = (0).toFixed(2)
            _copy.period = null
            _copy.updated_at = null
            _copy.updated_by = null
            this.edited = true
            state.items.push(_copy)
        },
        async delLine(index) {
            if (await this.$bvModal.msgBoxConfirm('Are you sure you want to delete line ' + index + '?',
                {
                    title: 'Please confirm delete action.',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })) {

                let result = []
                for (var j = 0; j < this.lines.length; ++j) {
                    if (j != index - 1) {
                        result.push(this.lines[j])
                    }
                }
                this.lines = result
                this.edited = true
            }
        },
        async openingbalances_load(offset, limit, page) {
            let state = this.openingbalances;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,

                // id: this.id,
                code: this.code,
                period: this.period,
                description: this.description,
                dateformat: "DD/MM/YYYY",
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query setup_openingbalances(
                        $limit: Int
                        $offset: Int
                        $code: String
                        $period: String
                        $description: String
                    
                        ) {
                        setup_openingbalances(
                            limit: $limit
                            offset: $offset
                            code: $code
                            period: $period
                            description: $description
                           
                        ) {
                            id
                            code
                            period
                            description
                            amount
                            updated_at
                            updated_by
                            rows
                        }
                        }
                    `,
                    variables,
                });

                // USE LOCAL VARIABLE
                if (limit == 0) {
                    state.selected = response.data.setup_openingbalances
                } else {
                    state.items = []
                    state.items = response.data.setup_openingbalances;
                }


            } catch (error) {
                console.log(error);
            }
            this.postit_ready()
            state.busy = false;
        },
        // async nlcode_update(index) {
        //     // console.log(this.lines[index].supply)
        //     let pick = this.supply_options.find(k => k.id == this.lines[index].bltype);
        //     if (pick) {
        //         this.lines[index].nlcode = pick.costsnl
        //     } else {
        //         this.lines[index].nlcode = null
        //     }
        // },
        // async postit_saveit() {

        //     this.busy = true

        //     let rows = []
        //     for (var j = 0; j < this.lines.length; ++j) {

        //         let lineitem = this.lines[j]

        //         if (parseFloat(lineitem.total) != 0) {

        //             let factor = this.type == 'credit' ? -1 : 1

        //             //PREPARE NEW BOUGHT LEDGER ENTRY
        //             let blentry = {
        //                 credit: this.type == 'credit' ? true : false,
        //                 prefix: lineitem.type,
        //                 line: (j + 1).toString(),

        //                 blac: this.blac,
        //                 eventcode: lineitem.eventcode,

        //                 costnl: lineitem.nlcode,
        //                 passenger: lineitem.description,
        //                 ticketno: lineitem.ticketno,
        //                 qty: lineitem.qty,

        //                 // REVIEW FROM HERE
        //                 taxes: "0.00",
        //                 costticket: (parseFloat(lineitem.price) * factor).toFixed(2),
        //                 costexvat: (parseFloat(lineitem.price) * factor).toFixed(2),
        //                 costvat: (parseFloat(lineitem.vat) * factor).toFixed(2),
        //                 costtotal: (parseFloat(lineitem.total) * factor).toFixed(2),
        //                 due: (parseFloat(lineitem.total) * factor).toFixed(2),

        //                 notes: this.notes,
        //                 yourref: this.yourref,
        //                 route: this.route
        //             }
        //             rows.push(blentry)
        //         }

        //     }

        //     let variables = { rows };

        //     try {
        //         const response = await this.$apollo.mutate({
        //             mutation: gql`
        //                 mutation BL_save(
        //                     $rows: [BLTransaction_input]
        //                 ) {
        //                     BL_save(rows: $rows) {
        //                         id
        //                         invoiceno
        //                 }
        //                 }
        //             `,
        //             variables,
        //         });

        //         // console.log(response);
        //         if (response.data.BL_save.length > 0) {

        //             this.message = "<span class='text-primary'>Saved it. " + response.data.BL_save[0].invoiceno + "</span>";
        //             // this.value.referenceno = response.data.BL_save[0].referenceno
        //         }

        //         this.edited = false
        //         this.posted = true

        //     } catch (error) {
        //         this.message = "<span class='text-danger'>" + error.message + "</span>";
        //     }

        //     this.busy = false
        // },
        postit_ready() {
            console.log('postit_ready')
            let state = this.openingbalances;

            //     this.value.type = this.type == 'invoice' ? 'IG' : 'CG'
            //     this.value.referenceno = this.value.type + '*new*'

            //     let subtotal = 0
            //     let vat = 0
            //     let total = 0

            //     if (!this.blac) {
            //         this.postit_disabled = true
            //         return
            //     }

            //     for (var k = 0; k < this.lines.length; k++) {
            //         let line = this.lines[k]

            //         line.type = this.value.type
            //         line.referenceno = this.value.referenceno
            //         line.blac = this.blac

            //         if (line.description) {
            //             line.description = line.description.toUpperCase()
            //         }
            //         if (line.ticketno) {
            //             line.ticketno = line.ticketno.toUpperCase()
            //         }
            //         if (line.price) {

            //             switch (line.vatrate) {
            //                 case "S":
            //                     line.vat = (parseFloat(line.total) * 0.2).toFixed(2)
            //                     break;
            //                 default:
            //                     line.vat = "0"
            //             }
            //             if (line.vat) {
            //                 vat += parseFloat(line.vat)
            //             }
            //             line.total = (parseFloat(line.price) + parseFloat(line.vat)).toFixed(2)
            //         }

            //         if (line.total) {
            //             subtotal += parseFloat(line.total)
            //         }
            //     }
            //     this.subtotal = (subtotal).toFixed(2)
            //     this.vat = (vat).toFixed(2)
            //     this.total = (subtotal + vat).toFixed(2)
            if (state.items.length > 0) {
                if (state.items[state.items.length - 1].code && parseFloat(state.items[state.items.length - 1].amount) != 0) {
                    console.log('calling addline')
                    this.addLine()
                }
                for (var k = 0; k < state.items.length; k++) {
                    let line = state.items[k]
                    // if (parseFloat(line.price) > 0 && !line.eventcode) {
                    //     this.message = "<span class='text-danger'>" + "Line " + (k + 1) + ". requires a valid event!" + "</span>"
                    //     this.postit_disabled = true
                    //     return
                    // }
                }
                this.message = ""
                this.postit_disabled = false
            }

        },
        // async saveit(ss) {

        //     this.busy = true;

        //     let variables = { rows: this.cleanit(ss) };

        //     try {
        //         const response = await this.$apollo.mutate({
        //             mutation: gql`
        //       mutation setup_openingbalances_save(
        //         $rows: [setup_openingbalances_input]             
        //       ) {
        //         setup_openingbalances_save(rows: $rows) {
        //             id
        //             nlcode
        //             description
        //             period
        //             amount   
        //             updated_at
        //             updated_by                 
        //         }
        //       }
        //     `,
        //             variables,
        //         });
        //         this.message = "<span class='text-primary'>Saved it.</span>";
        //     } catch (error) {
        //         this.message = "<span class='text-danger'>" + error.message + "</span>";
        //     }

        //     this.busy = false;
        // },
        // async deleteit(ss) {
        //     // console.log("deleteit", ss);

        //     let rows = [];
        //     ss.forEach(function (v) {
        //         rows.push({ id: v.id });
        //     });

        //     let variables = {
        //         rows,
        //     };

        //     try {
        //         const response = await this.$apollo.mutate({
        //             mutation: gql`
        //       mutation setup_openingbalances_delete(
        //         $rows: [setup_openingbalances_input]
        //       ) {
        //         setup_openingbalances_delete(rows: $rows) {
        //           id
        //         }
        //       }
        //     `,
        //             variables,
        //         });
        //     } catch (error) {
        //     }

        //     await this.openingbalances_load(0);
        // },

    },
};
</script>